export const PLAYER_CATEGORIES = [
    { label: "Master", value: new Date(2000, 0, 1, 0, 0, 0, 0) },
    { label: "Senior", value: new Date(2009, 0, 1, 0, 0, 0, 0) },
    { label: "Junior", value: new Date(2015, 0, 1, 0, 0, 0, 0) }
];
